import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import Transaction from '../Pages/TransactionResult/index';
import './App.css';

function App() {
  return (
    <div className='App'>
      <Router>
        <Routes>
          <Route path='/transaction/:result' element={<Transaction />}></Route>
        </Routes>
      </Router>
    </div>
  );
}

export default App;
